import React from 'react';
import PropTypes from 'prop-types';

export default function EmptyChart({ colors }) {
  /* eslint-disable max-len */
  return (
    <svg width="268" height="268" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M39.3323 251.255C63.3611 277.518 95.9465 294.379 131.264 298.825C166.582 303.271 202.33 295.013 232.118 275.526L191.059 212.763C176.165 222.506 158.291 226.636 140.632 224.413C122.973 222.19 106.681 213.759 94.6661 200.628L39.3323 251.255Z" fill={colors[1000]} />
      <path d="M264.857 53.5228C249.012 34.659 228.765 19.9882 205.904 10.8068C183.043 1.62527 158.273 -1.78429 133.782 0.879344L141.891 75.4397C154.136 74.1079 166.522 75.8126 177.952 80.4034C189.382 84.9941 199.506 92.3295 207.429 101.761L264.857 53.5228Z" fill={colors[800]} />
      <path d="M53.2686 35.3569C71.4103 20.0497 92.9257 9.26636 116.046 3.89337L133.023 76.9467C121.463 79.6332 110.705 85.0248 101.634 92.6785L53.2686 35.3569Z" fill={colors[600]} />
      <path d="M245.453 265.71C274.174 242.017 293.057 208.489 298.43 171.646C303.803 134.803 295.282 97.2787 274.523 66.3699L212.262 108.185C222.641 123.639 226.901 142.402 224.215 160.823C221.529 179.244 212.087 196.008 197.726 207.855L245.453 265.71Z" fill={colors[400]} />
      <path d="M27.9849 237.249C7.80162 209.023 -1.97151 174.672 0.330429 140.049C2.63237 105.426 16.867 72.6717 40.6093 47.3663L95.3047 98.6831C83.4335 111.336 76.3162 127.713 75.1652 145.025C74.0142 162.336 78.9008 179.511 88.9925 193.624L27.9849 237.249Z" fill={colors[200]} />
    </svg>
  );
  /* eslint-enable max-len */
}

EmptyChart.propTypes = {
  colors: PropTypes.object.isRequired,
};
